import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DatiContabiliDTO } from "../dto/dati-contabiliDTO";
import { DatiContabiliVO } from "../vo/dati-contabiliVO";

@Injectable({ providedIn: "root" })
export class MapperDatiContabili
  implements MapperInterface<DatiContabiliDTO, DatiContabiliVO> {
  constructor(
  ) { }

  convertVoToDto(datiVo: DatiContabiliVO): DatiContabiliDTO {
    if (datiVo != null) {
      // console.log("[MapperSettore] AttivitaVO => AttivitaDTO", attivitaVO);
      const datiDTO = new DatiContabiliDTO();

      datiDTO.importo = datiVo.importo;
      datiDTO.voceBilancio = datiVo.voceBilancio;
      datiDTO.area = datiVo.area;
      datiDTO.conto = datiVo.conto;
      datiDTO.capienza = datiVo.capienza;
      datiDTO.residuo = datiVo.residuo;
      datiDTO.dataInizio = datiVo.dataInizio;
      datiDTO.dataFine = datiVo.dataFine;
      datiDTO.esercizio = datiVo.esercizio;
      datiDTO.periodo = datiVo.periodo;
      // console.log("return", attivitaDTO);
      return datiDTO || new DatiContabiliDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(datoDTO: DatiContabiliDTO): DatiContabiliVO {
    if (datoDTO != null) {
        console.log("[MapperDatiContabili] DatiContabiliDTO => DatiContabiliVO", datoDTO);
      const datiVO = new DatiContabiliVO();

      datiVO.importo = datoDTO.importo;
      datiVO.residuo = datoDTO.residuo;
      datiVO.voceBilancio = datoDTO.voceBilancio;
      datiVO.conto = datoDTO.conto;
      datiVO.area = datoDTO.area;
      datiVO.capienza = datoDTO.capienza;
      datiVO.dataInizio = datoDTO.dataInizio;
      datiVO.dataFine = datoDTO.dataFine;
      datiVO.esercizio = datoDTO.esercizio;
      datiVO.periodo = datoDTO.periodo;
       console.log("[MapperDatiContabili] fine DatiContabiliDTO => AttiviDatiContabiliVOtaVO", datiVO);
      return datiVO || new DatiContabiliVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(datiVOList: DatiContabiliVO[]): DatiContabiliDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const datiDTOList = new Array<DatiContabiliDTO>();
    datiVOList.forEach((vo) => {
      datiDTOList.push(this.convertVoToDto(vo));
    });

    return datiDTOList || new Array<DatiContabiliDTO>();
  }

  convertListDtoToVo(datiDTOList: DatiContabiliDTO[]): DatiContabiliVO[] {
    // console.log("[MapperSettori] attivitaDTOList => attivitaDTOList");
    // console.log("attivitaDTOList", attivitaDTOList);
    const attivitaVOList = new Array<DatiContabiliVO>();
    datiDTOList.forEach((dto) => {
      attivitaVOList.push(this.convertDtoToVo(dto));
    });

    return attivitaVOList || new Array<DatiContabiliVO>();
  }
}
